import { render, staticRenderFns } from "./ReportedMes.vue?vue&type=template&id=4ca777a6&scoped=true"
import script from "./ReportedMes.vue?vue&type=script&lang=js"
export * from "./ReportedMes.vue?vue&type=script&lang=js"
import style0 from "./ReportedMes.vue?vue&type=style&index=0&id=4ca777a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca777a6",
  null
  
)

export default component.exports